//don't add imports here, imported directly from main entry.
export var getMadeForFontUrl = function (scriptsDomainUrl) {
    return "".concat(scriptsDomainUrl, "unpkg/@wix/wix-fonts@1.11.0/madefor.min.css");
};
